import Bugsnag from "@bugsnag/js";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_RELATED_TAGS } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { showNotification } from "@/redux/actions/notification";
import { lenderHubProfileService } from "@/features/LenderHub/Profile/services/profileService";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";

const bulkAddLendingProgramsEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    bulkAddLendingPrograms: builder.mutation({
      query: (programs) => ({
        url: "lending-programs/bulk",
        method: "POST",
        body: { programs },
      }),
      invalidatesTags: LENDING_PROGRAM_RELATED_TAGS,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const count = Array.isArray(data) ? data.length : 1;
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: `${count} Lending Program${count > 1 ? "s" : ""} have been created!`,
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );
          dispatch(lenderHubProfileService.util.invalidateTags(["LenderHubProfile"]));
          dispatch(lenderHubDealService.util.invalidateTags(["LenderHubDeal"]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useBulkAddLendingProgramsMutation } = bulkAddLendingProgramsEndpoint;
